import clsx from "clsx"
import { useTranslation } from "react-i18next"

function Title() {
  const { t } = useTranslation()
  return (
    <section className="flex flex-col items-center justify-center">
      <h1
        className={clsx(
          "mb-4 text-center",
          "text-6xl font-bold sm:text-8xl",
          "relative",
          "relief-text"
        )}
      >
        <span
          className={clsx(
            "relative z-10",
            "bg-gradient-to-r from-amber-500 via-red-500 to-amber-500",
            "bg-clip-text text-transparent"
          )}
        >
          {t("aboutPage.title")}
        </span>
        <span
          className={clsx(
            "absolute inset-0",
            "translate-x-[1px] translate-y-[1px]",
            "text-zinc-500"
          )}
          aria-hidden="true"
        >
          {t("aboutPage.title")}
        </span>
      </h1>
      <h2
        className={clsx(
          "mb-4 text-center",
          "relative",
          "relief-text",
          "text-lg sm:text-xl",
          "max-w-2xl"
        )}
      >
        <span className={clsx("relative z-10", "text-amber-400")}>
          {t("aboutPage.catchphrase")}
        </span>
        <span
          className={clsx(
            "absolute inset-0",
            "translate-x-[1px] translate-y-[1px]",
            "text-zinc-500"
          )}
          aria-hidden="true"
        >
          {t("aboutPage.catchphrase")}
        </span>
      </h2>
    </section>
  )
}

export default Title
